<template>
  <v-sheet class="item-images" color="transparent">
    <zoom-on-hover
      v-if="featuredImg"
      :img-normal="`${featuredImg}?resize=1&w=500`"
      :img-zoom="`${featuredImg}?resize=1&w=1000`"
      :scale="1"
      class="d-flex align-center justify-center item-image-highlight"
    />

    <div v-if="list" class="mt-4 mt-md-0 justify-md-end">
      <hooper-container
        :settings="hooperSettings"
        class="carousel-product-item"
      >
        <hooper-slide v-for="(img, key) in list" :key="key">
          <v-btn
            @mouseover="featuredImg = img"
            href="javascript:void(0);"
            :class="
              `pa-0 item-image-thumbnail` +
              (featuredImg === img ? ` active` : ``)
            "
            height="80px"
            width="80px"
            depressed
            tile
          >
            <img
              :src="`${img}?resize=1&w=65`"
              :alt="item.title"
              class="item-image"
            />
          </v-btn>
        </hooper-slide>
      </hooper-container>
    </div>
  </v-sheet>
</template>

<script>
export default {
  props: {
    featuredImg: {
      type: String,
      required: true,
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    hooperSettings: {
      itemsToShow: 3,
      vertical: false,
      breakpoints: {
        360: {
          itemsToShow: 4,
          vertical: false,
        },
        450: {
          itemsToShow: 5,
          vertical: false,
        },
        600: {
          itemsToShow: 3,
          vertical: false,
        },
        700: {
          itemsToShow: 4,
          vertical: false,
        },
        960: {
          itemsToShow: 4,
          vertical: true,
        },
        1200: {
          itemsToShow: 5,
          vertical: true,
        },
      },
    },
  }),
};
</script>

<style lang="scss" scoped>
.item-image-highlight::v-deep {
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.15) !important;
  padding: 20px;
  width: 100%;

  .normal {
    aspect-ratio: 1 / 1;
    display: block;
    object-fit: contain;
    -o-object-fit: contain;
    width: 100%;
  }
}

.item-images {
  display: grid;
  grid-template-columns: auto 100px;

  @media screen and (max-width: 960px) {
    display: flex;
    flex-direction: column;
  }

  .item-image {
    max-height: 80px;
    max-width: 80px;
    object-fit: contain;
    -o-object-fit: contain;
    object-position: center;
    -o-object-position: center;
    width: 100%;
  }
}

.carousel-product-item::v-deep {
  height: 100% !important;
  width: 100%;
}
</style>
